import PhoneNumber from "awesome-phonenumber";

export function normalizeClientPhone(raw, country) {
    const number = String(raw || "").trim();
    if (!number) return { number: null, country, valid: false };
    try {
        const phone = new PhoneNumber(number, country);
        if (phone.isValid()) return { number: phone.getNumber("international"), country: phone.getRegionCode() || country, valid: true };
    } catch {
        // Invalid input must reach the usual API validation rather than silently losing contact data.
    }
    return { number: raw, country, valid: false };
}
